<template>
  <div class="single-product-wish-list-1" @click="itemToWishListWrapper">
    <m-icon :icon="wishListStatus ? 'heart-fill' : 'heart' "/>
    <span class="mx-2" v-t="`wishList.product_button.button_text`"></span>
  </div>
</template>

<script>
import mIcon from "../../Icons/Icon.vue";
import {mapActions, mapGetters} from "vuex";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "WishListButton1",
  components: {mIcon},
  props: {
    itemable_type: {
      default: 'product'
    },
    itemable_id: {
      default: null
    },
  },
  data() {
    return {
      wishListStatus: false
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "User/isAuthenticated",
    })
  },
  methods: {
    ...mapActions({
      addItemToWishList: "WishList/addItemToWishList",
      removeItemFromWishList: "WishList/removeItemFromWishList",
      checkItemWishListed: "WishList/checkItemWishListed",
    }),
    itemToWishListWrapper() {
      if (this.isAuthenticated) {

        let form = {
          itemable_type: this.itemable_type,
          itemable_id: this.itemable_id,
        }

        if (this.wishListStatus) {
          this.removeItemFromWishList(form).then(res => {
            this.wishListStatus = false
          })
        } else {
          this.addItemToWishList(form).then(res => {
            this.wishListStatus = true
          })
        }

        return true
      }
      toast(this.$t('wishList.product_button.un_authenticated_error_message'), this.$t('wishList.product_button.un_authenticated_error_message'), 'danger')
    },
    checkItemWishListedWrapper() {

      let form = {
        itemable_type: this.itemable_type,
        itemable_id: this.itemable_id,
      }

      let req = this.checkItemWishListed(form)
      req.then(res => {
        this.wishListStatus = res.data.data
      })


    }
  },
  mounted() {

  },
  watch: {
    itemable_id: {
      handler(newValue, oldValue) {
        if (newValue != null && this.isAuthenticated) {
          this.checkItemWishListedWrapper()
        }
      },
    }
  }
}
</script>

<style scoped>
.single-product-wish-list-1 {
  cursor: pointer;
}
</style>